<template>
  <el-form center>
    <el-row class="tac">
      <el-col :span="24">
        <el-form-item
          label="(日)额度设置："
          style="margin-left: 120px"
          class="limit-configure"
        >
          <el-col :span="4">
            <el-form-item label="总" label-width="40px">
              <el-input
                v-model.number="form.day.all"
                :size="input_size"
                @change="handleSubmitLimitConfigure"
              ></el-input>
            </el-form-item>
          </el-col>
          <span v-if="!hidden">
            <el-col class="inline" :span="4">
              <el-form-item label="普" label-width="40px">
                <el-input
                  v-model.number="form.day.pu"
                  :size="input_size"
                  @change="handleSubmitLimitConfigure"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="inline" :span="4">
              <el-form-item label="精" label-width="40px">
                <el-input
                  v-model.number="form.day.jing"
                  :size="input_size"
                  @change="handleSubmitLimitConfigure"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="特" label-width="40px">
                <el-input
                  v-model.number="form.day.te"
                  :size="input_size"
                  @change="handleSubmitLimitConfigure"
                ></el-input>
              </el-form-item>
            </el-col>
          </span>
          (说明：-1禁用;0不限制;大于0:具体额度)
          <el-row style="margin-left: 60px; clear: both"> </el-row>
        </el-form-item>
        <el-form-item
          label="(个人/日)额度设置："
          style="margin-left: 120px"
          class="limit-configure"
        >
          <el-input
            v-model.number="form.user_common_quota"
            :size="input_size"
            @change="handleSubmitLimitConfigure"
          ></el-input>
        </el-form-item>
        <el-table
          :data="form.batch"
          style="width: 100%"
          class="limit-subject-configure"
        >
          <el-table-column label="科目" center>
            <template slot-scope="scope">
              <div>{{ scope.row.subject_name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="小学">
            <el-table-column label="精">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.primary.jing"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'primary', 'jing')"
                  :size="input_size"
                >
                </el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 1)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 1)[7] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="普">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.primary.pu"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'primary', 'pu')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 1)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 1)[8] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="特">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.primary.te"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'primary', 'te')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 1)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 1)[17] }}</span
                >
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="初中">
            <el-table-column label="精">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.middle.jing"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'middle', 'jing')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 2)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 2)[7] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="普">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.middle.pu"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'middle', 'pu')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 2)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 2)[8] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="特">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.middle.te"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'middle', 'te')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 2)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 2)[17] }}</span
                >
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="高中">
            <el-table-column label="精">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.high.jing"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'high', 'jing')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 3)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 3)[7] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="普">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.high.pu"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'high', 'pu')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 3)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 3)[8] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="特">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.high.te"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'high', 'te')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 3)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 3)[17] }}</span
                >
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="中职">
            <el-table-column label="精">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.vsh.jing"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'vsh', 'jing')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 4)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 4)[7] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="普">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.vsh.pu"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'vsh', 'pu')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 4)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 4)[8] }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="特">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.config.vsh.te"
                  style="width: 50px"
                  @input="setLimit(scope.row.subject_id, 'vsh', 'te')"
                  :size="input_size"
                ></el-input>
                <span
                  v-if="showDownload(scope.row.subject_id, 4)"
                  style="color: red"
                  >{{ showDownload(scope.row.subject_id, 4)[17] }}</span
                >
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-form>
</template>

<style scoped>
.app-main .main-bd .el-row {
  padding: 10px 0;
}
</style>

<script>
import CommonService from "~/services/common";
export default {
  data() {
    return {
      input_size: "mini",
      subjects: [],
      form: {
        day: {
          all: 0,
          pu: 0,
          jing: 0,
          te: -1,
        },
        user_common_quota: 0,
        product_code: "",
        batch: [],
      },
      configUsed: false,
      formLabelWidth: "120px",
    };
  },
  props: {
    type: {
      required: true,
    },
    params: {
      required: true,
    },
    hidden: {
      required: false,
    },
  },
  computed: {
    count_all() {
      let jing = this.form.day.jing >= 0 ? this.form.day.jing : 0;
      let pu = this.form.day.pu >= 0 ? this.form.day.pu : 0;
      let te = this.form.day.te >= 0 ? this.form.day.te : 0;
      this.form.day.all = jing + pu + te;
      return this.form.day.all;
    },
  },
  mounted() {
    /**
     * 试用订单的校本默认日总额度：150
     *正式订单的校本默认日总额度：500
     */
    this.form.day.all = 500;
    if (this.type == 1) {
      this.form.day.all = 150;
    }
    if (typeof this.params.day != "undefined") {
      this.form.day = this.params.day;
    }
    if (typeof this.params.batch != "undefined") {
      this.form.batch = this.params.batch;
    }
    if (typeof this.params.user_common_quota != "undefined") {
      this.form.user_common_quota = this.params.user_common_quota;
    }
    if (typeof this.params.product_code != "undefined") {
      this.form.product_code = this.params.product_code;
      this.getConfigUsed();
    }
    if (this.form.batch.length == 0) {
      /**获取批量设置列表 */
      this.getBatch();
    } else {
      CommonService.getAllSubjects().then((res) => {
        this.subjects = Object.keys(res.data).map((key) => {
          return res.data[key];
        });
        this.subjects.unshift({
          subject_id: 0,
          subject_name: "所有科目",
        });
        var arr = [];
        this.subjects.map((sub, k) => {
          let obj = {};
          let filter = this.form.batch.filter((bat) => {
            return sub.subject_id == bat.subject_id;
          });
          obj = Object.assign(
            filter.length > 0
              ? filter[0]
              : {
                  config: {
                    vsh: { jing: 0, pu: 0, te: -1 },
                    high: { jing: 0, pu: 0, te: -1 },
                    middle: { jing: 0, pu: 0, te: -1 },
                    primary: { jing: 0, pu: 0, te: -1 },
                  },
                },
            sub
          );
          arr.push(obj);
        });
        this.form.batch = arr;
      });
    }
    this.handleSubmitLimitConfigure();
  },
  methods: {
    get_init_config() {
      return {
        primary: {
          pu: 0,
          jing: 0,
          te: -1,
        },
        middle: {
          pu: 0,
          jing: 0,
          te: -1,
        },
        high: {
          pu: 0,
          jing: 0,
          te: -1,
        },
        vsh: {
          pu: 0,
          jing: 0,
          te: -1,
        },
      };
    },

    handleSubmitLimitConfigure() {
      this.$emit("handleSubmitLimitConfigure", this.form);
    },
    /**@description 所有科目设置 */
    setLimit(val, stage, type) {
      if (val !== 0) {
        return false;
      }
      this.form.batch.forEach((item) => {
        let obj = this.form.batch[0].config;
        let clone_obj = Object.assign({}, obj[stage]);
        item.config[stage][type] = clone_obj[type];
      });
      this.handleSubmitLimitConfigure();
    },
    /**@description 额度批量设置 */
    getBatch() {
      var subjects = [];
      CommonService.getAllSubjects().then((res) => {
        subjects = res.data;
      });
      subjects.unshift({
        subject_id: 0,
        subject_name: "所有科目",
      });
      this.form.batch = subjects.map((item) => {
        item.config = this.get_init_config();
        return item;
      });
    },
    showDownload(subject_id, type) {
      if (!subject_id) return false;
      if (!this.configUsed) return false;
      if (!this.configUsed[subject_id]) return false;
      if (typeof this.configUsed[subject_id] != "undefined") {
        return this.configUsed[subject_id][type];
      }
      return false;
    },
    getConfigUsed() {
      CommonService.getConfigUse({
        customer_id: this.$route.query["id"],
        product_code: this.params.product_code,
      }).then((res) => {
        if (!res.code) {
          this.configUsed = res.data;
        }
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/order/jiaoben/limitConfigure.vue